module.exports = __webpack_public_path__ + "assets/img/help_image01-4.722b409c.png";